import './src/styles/global.css';

// Load Material Symbols after first render so it never blocks FCP/LCP
export const onInitialClientRender = () => {
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href =
    'https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200';
  document.head.appendChild(link);
};
